import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {LOCAL_STORAGE} from '@ng-web-apis/common';
import {GoogleTagService} from '@core/services/google-tag.service';
import {GoogleAdsService} from '@core/services/google-ads.service';
import {ConsentFormValues} from '@ui/consent-banner/consent-banner.component';
import {environment} from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConsentService {
  readonly consentName = `consent#${environment.name}-ott`;

  constructor(
    @Inject(DOCUMENT) readonly document: Document,
    @Inject(LOCAL_STORAGE) readonly localStorage: Storage,
    private readonly googleTagService: GoogleTagService,
    private readonly googleAdsService: GoogleAdsService,
  ) {}

  setConsentCookie(value: ConsentFormValues): void {
    const values = JSON.stringify(value);

    this.googleTagService.updateConsentGtag(value);

    if (value.googleMarketingPersonalization) {
      this.googleAdsService.startAds();
    }

    this.localStorage.setItem(this.consentName, values);
  }

  getConsentCookie(): ConsentFormValues | null {
    return this.localStorage.getItem(this.consentName)
      ? JSON.parse(this.localStorage.getItem(this.consentName) as string)
      : null;
  }

  getBradmaxConsentCookie(): boolean {
    const consentCookie = this.getConsentCookie();

    if (consentCookie) {
      return consentCookie.bradmax as boolean;
    }

    return false;
  }

  getGoogleMarketingPersonalizationConsent(): boolean {
    const consentCookie = this.getConsentCookie();

    if (consentCookie) {
      return consentCookie.googleMarketingPersonalization;
    }

    return false;
  }
}
